/**
 * Support Ticket Redux Slice
 * Manages ticket state from WebSocket updates
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  openCount: 0,
  connected: false,
  lastUpdated: null,
};

const ticketSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    setTickets: (state, action) => {
      state.items = action.payload;
      state.openCount = action.payload.filter(
        (t) => t.status === 'open' || t.status === 'in_progress'
      ).length;
      state.lastUpdated = new Date().toISOString();
    },

    addTicket: (state, action) => {
      state.items.unshift(action.payload);

      if (action.payload.status === 'open' || action.payload.status === 'in_progress') {
        state.openCount += 1;
      }

      state.lastUpdated = new Date().toISOString();
    },

    updateTicket: (state, action) => {
      const index = state.items.findIndex((t) => t.id === action.payload.id);

      if (index !== -1) {
        const wasOpen =
          state.items[index].status === 'open' || state.items[index].status === 'in_progress';
        const isOpen = action.payload.status === 'open' || action.payload.status === 'in_progress';

        state.items[index] = action.payload;

        // Adjust open count
        if (wasOpen && !isOpen) {
          state.openCount = Math.max(0, state.openCount - 1);
        } else if (!wasOpen && isOpen) {
          state.openCount += 1;
        }

        state.lastUpdated = new Date().toISOString();
      }
    },

    setConnected: (state, action) => {
      state.connected = action.payload;
    },

    clearTickets: (state) => {
      state.items = [];
      state.openCount = 0;
      state.connected = false;
      state.lastUpdated = null;
    },
  },
});

export const { setTickets, addTicket, updateTicket, setConnected, clearTickets } =
  ticketSlice.actions;

// Selectors
export const selectTickets = (state) => state.tickets.items;
export const selectOpenCount = (state) => state.tickets.openCount;
export const selectTicketConnected = (state) => state.tickets.connected;

// Filtered selectors
export const selectTicketsByStatus = (status) => (state) =>
  state.tickets.items.filter((t) => t.status === status);

export default ticketSlice.reducer;
